import {Component, computed, contentChildren, effect, inject, input, model, output, untracked} from '@angular/core';
import {TabsService} from '@shared/container/tabs/tabs.service';
import {LucideAngularModule} from 'lucide-angular';
import {TabItemComponent} from '@shared/container/tabs/tab-item/tab-item.component';

@Component({
  selector: 'app-tabs',
  providers: [
    // the parent is responsible to provide TabsService
  ],
  imports: [
    LucideAngularModule
  ],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss'
})
export class TabsComponent {
  public readonly theme = input<'default' | 'primary' | 'secondary'>('default');
  public readonly border = input(true);
  public readonly tabs = contentChildren(TabItemComponent);

  public readonly selectTab = output<TabItemComponent>();

  private readonly service = inject(TabsService);
  public readonly isSelectedTabInvalid = computed(() => !!this.service.selectedTab()?.isInvalid());

  constructor() {
    effect(() => {
      const selectedTab = this.service.selectedTab();
      if (selectedTab) {
        this.selectTab.emit(selectedTab);
      }
    });
  }

  public select(tab: TabItemComponent): void {
    if (this.isSelectedTabInvalid()) {
      return;
    }
    this.service.select(tab);
  }
}
